export const contractAddress =
  'erd1qqqqqqqqqqqqqpgquvt728n40ssd8n2qns9jrlqpwq2jc4rj4cysfuj3ad';

export const eventsAddress = 'erd1tqxp0wyjdter2wjpt6g8qytksz9u56kyyq732neqh88w74z6eyjq7xgztg';

export const dAppName = 'ERMS';
